import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import GrayPanel from '../../components/GrayPanel';

const errorSpanStyle = {
  color: 'red',
  fontSize: '10px',
};

// layout classes
const leftCol = 'col-sm-2';
const labelCol = 'col-sm-2';
const inputCol = 'col-sm-6';
const rightCol = 'col-sm-2';

// really simple styles
const labelStyle = { marginTop: '.5rem' };
const rowStyle = { marginTop: '15px' };

class PersonalData extends React.Component {
  state = {};

  onChange = (e, attr) => {
    const value = e.target.value;
    this.setState({[attr]: value }, () => {
      this.props.onChangePersonalData && this.props.onChangePersonalData(attr, value);
    });
  };

  componentDidMount() {
    this.props.userData && this.setState(this.props.userData);
  }

  render() {
    const formDict = {
      FirstName: {
        label: 'Imię',
      },
      LastName: {
        label: 'Nazwisko',
      },
      FullName: {
        label: 'Nazwa wnioskodawcy',
      },
      AddressCity: {
        label: 'Miejscowość',
      },
      AddressStreet: {
        label: 'Ulica',
      },
      AddressNumber: {
        label: 'Numer budynku',
      },
      AddressFlat: {
        label: 'Numer lokalu',
      },
      AddressZipCode: {
        label: 'Kod pocztowy',
      },
      AddressMail: {
        label: 'Poczta',
      },
      PhoneNumber: {
        label: 'Telefon',
      },
      Email: {
        label: 'Email',
      },
      Regon: {
        label: 'REGON',
      },
      Nip: {
        label: 'NIP',
      },
    };

    return (
      <GrayPanel title="1. Dane wnioskodawcy: ">
        {Object.keys(formDict).map((v, i) => {
          return (
            <div className="row mobile-row" key={i} style={rowStyle}>
              <div className={leftCol} />
              <div className={labelCol}>
                <label style={labelStyle}>{formDict[v].label}</label>
              </div>
              <div className={inputCol}>
                <input
                  className="form-control"
                  value={this.state[v] ? this.state[v] : ''}
                  onChange={e => this.onChange(e, v)}
                  disabled={!(this.props.isDisabled==null || this.props.isDisabled==undefined) ? this.props.isDisabled : true}
                  style={{
                    width: '100%',
                    borderColor:
                      this.props.errors &&
                      Object.keys(this.props.errors).indexOf(v) > -1 &&
                        this.props.errors[v] !== null &&
                        this.props.errors[v].length > 0
                        ? 'red'
                        : '#ccc',
                  }}
                />
                {/* RENDER ERROS IN SPAN */}
                {this.props.errors &&
                  Object.keys(this.props.errors).indexOf(v) > -1 &&
                  this.props.errors[v] !== null &&
                  this.props.errors[v].length > 0
                  ? this.props.errors[v].map((val, index) => (
                    <span key={index} style={errorSpanStyle}>
                      {val}
                    </span>
                  ))
                  : null}
              </div>
              <div className={rightCol} />
            </div>
          );
        })}
      </GrayPanel>
    )
  }
}


export default PersonalData;


// WEBPACK FOOTER //
// src/containers/PersonalData/index.jsx